import React from 'react';
import ProjectStyleFour from '../components/project/ProjectStyleFour';
import FooterOne from '../common/footer/FooterOne';
import HeaderBottomOne from '../common/header/HeaderBottomTwo';

const Menu = () => {
    return (
        <>
            {/*<HeaderTop />*/}
            <HeaderBottomOne />
            {/* <Breadcrumb 
                breadcrumbBg={breadcrumbBg}
                heading="Το Μενού μας"
                description="Ανακαλύψτε το μενού μας σήμερα και ετοιμαστείτε για μια πραγματική γευστική περιπέτεια!"
                currentPage="Το Μενού μας" 
            /> */}
            <ProjectStyleFour />
            {/* <CtaTwo /> */}
            {/* <WhyChoseUsTwo /> */}
            {/* <Subscribe /> */}
            <FooterOne />
           
        </>
    )
}

export default Menu;